import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useGetStatusConfig } from './hooks/useGetStatusConfig';
import moment from 'moment';
import { getContentInfoLive } from '../../../../utils/getDataFromLiveVodContent';
import { useGetRecord } from './hooks/useGetRecord';
import { useHasReminder } from './hooks/useHasReminder';
import { useAddBookmark } from './hooks/useAddBookmark';
//--------------------------------------------------------------------------------------------
import './style.scss';

//Obtiene el horario del evendo, 17:25 - 18:25
export const getScheduleTime = (beginTime, endTime) => {
  const start = moment(beginTime, 'HH:mm');
  const end = moment(endTime, 'HH:mm');

  if (!start.isValid() || !end.isValid()) return '-';
  return `${moment(beginTime, 'HH:mm').format('H[:]mm')} - ${moment(
    endTime,
    'HH:mm',
  ).format('H[:]mm')}`;
};

export const LiveInfo = ({ contentInfo }) => {
  const {
    content_data_livechannel_icon,
    playingLive_fullEpg_reminder_icon,
  } = useSelector(state => state.asset);
  const generalInfo = getContentInfoLive(contentInfo);
  const { statusLabel, futureEventDate } = useGetStatusConfig(
    generalInfo?.begintime,
    generalInfo?.endtime,
    contentInfo?.id,
  );

  useAddBookmark(generalInfo?.begintime, generalInfo?.endtime, contentInfo?.id);

  //Hook para determinar si un contenido esta grabado
  const { hasBeenRecord, recordingStatusIcon } = useGetRecord(
    contentInfo,
    generalInfo,
  );
  //hook para determinar si un contenido tiene un recrdatorio
  const { hasReminder } = useHasReminder(contentInfo);
  const hasTwoAssets = hasBeenRecord && hasReminder;
  return (
    <div className="live-info">
      <img
        src={content_data_livechannel_icon}
        alt="claro video live"
        className={`live-info__tv-icon ${hasTwoAssets ? 'twoAssets' : ''}`}
      />
      {statusLabel} {/* <--- Label ya emitido, ahora, mas tarde */}
      {hasBeenRecord && (
        <img
          className="live-info__recording"
          src={recordingStatusIcon}
          alt="record"
        />
      )}
      {hasReminder && (
        <div className="live-info__reminder">
          <img src={playingLive_fullEpg_reminder_icon} alt="reminder" />
        </div>
      )}
      {/* <---- Asset de recordatorio */}
      <div className={`live-info__date${hasTwoAssets ? '__twoAsset' : ''} `}>
        <p>
          {futureEventDate !== null && `${futureEventDate} | `}
          {getScheduleTime(
            generalInfo?.begintime?.split(' ')?.[1],
            generalInfo?.endtime?.split(' ')?.[1],
          )}
        </p>
      </div>
    </div>
  );
};

LiveInfo.propTypes = {
  contentInfo: PropTypes.object.isRequired,
};
